export function Logo() {
  return (
    <div className="mb-5 flex w-full items-center justify-center sm:mb-6">
      <img
        src="/LibertyRent_Logo_Horizontal_SCLA_PMS2217.png"
        alt="Liberty Rent"
        className="h-auto w-full max-w-[200px] sm:max-w-[240px] md:max-w-[280px]"
      />
    </div>
  )
}
